export default "/images/star-outline.svg?8bbfd788164b79b2f1b0a7066718d3d4";